import { Colors } from '@/public/styles/utils/variables';

export enum GraphicSeriesSourceType {
    Analysis = 'analysis',
    Controller = 'controller',
    Lab = 'lab',
    Product = 'product',
    Meter = 'meter',
}

export const serieInitialData = {
    component: null as string | null,
    analysisType: null as string | null,
};

// Base palettes
export const defaultColors = [
    '#CB3A32',
    Colors.serieA,
    '#5EC16A',
    '#ffa500',
    Colors.serieB,
    '#16a085',
];

export const seriesColors = [Colors.serieA, Colors.serieB, Colors.serieC, Colors.serieD];

// Core colors
export const chartWhite = '#ffffff';
export const chartBlack = '#000000';

// Text colors
export const chartTextPrimary = '#333333';
export const chartTextSecondary = '#666666';
export const chartTextMuted = '#555555';

// Axes and grid
export const chartAxisColor = '#9e9e9e';
export const chartAxisBaselineColor = '#cccccc';
export const chartGridColor = '#cfcfcf';
export const chartGridLightColor = '#f0f0f0';

// Brand / accents
export const brandPrimary = '#1976d2';
export const brandPrimaryFaint = 'rgba(25, 118, 210, 0.15)';

export const currentWorkOrderPointColor = Colors.aquassistGray2;
export const currentWorkOrderPointRadius = 4;
export const currentWorkOrderPointStrokeWidth = 1.5;
export const currentWorkOrderDashArray = '5,4';

// Donut specifics (aliases)
export const donutInnerFill = chartWhite;
export const donutSeparatorStroke = chartWhite;
